/**
 * Local ASR creation policy for TT-826+ wiring. Runtime asset URLs come from the
 * TT-825 manifest, while model decode and streaming thresholds stay on `asr.decode`
 * after `createAsr()` reads the hosted preprocess config.
 */

import { Backend } from './engine/asr';
import { getCreateAsrAssetOptions } from './asrAssetManifest';

/**
 * Integration-owned ASR startup defaults. The rolling phrase cadence is not this
 * `strideMs`; TT-827 reads `asr.decode.streaming.rollingStrideMs` and advances its
 * own fixed 1025ms window by sample count.
 */
export const LOCAL_ASR_CONFIG = Object.freeze({
  backend: Backend.Wasm,
  strideMs: null,
});

/**
 * Builds the options object for `createAsr()` using TT-825 hosted assets and TT-826
 * startup policy. Beam, consensus, and streaming thresholds intentionally remain on
 * the created instance's `asr.decode` object.
 * @returns {{modelUrl: string, vocabUrl: string, configUrl: string, wasmDir: string, backend: string, strideMs: null}}
 */
export function getLocalAsrCreateOptions() {
  return {
    ...getCreateAsrAssetOptions(),
    ...LOCAL_ASR_CONFIG,
  };
}
